// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_sv-0";